<template>
<div class="flex-column">
  <sticky :className="'sub-navbar'">
    <div class="filter-container">
      <permission-btn moduleName='computationUnits' size="mini" v-on:btn-event="onBtnClicked"></permission-btn>
    </div>
  </sticky>
  <div class="app-container flex-item">
     <div class="bg-white fh" id='computationUnits-table'>
        <!-- fit:列的宽度是否自撑开,宽度自适应    highlight-current-row：突出显示当前行-->
         <el-table ref="mainTable" :key='tableKey' :data="list" v-loading="listLoading" border fit highlight-current-row
             style="width: 100%;" height="calc(100% - 52px)" @row-click="rowClick"  @selection-change="handleSelectionChange" @sort-change="handleSortChange">
            <!--使用服务器返回的表头，如果复杂的表头和格式解析，请自己定义表格格式-->
            <!-- type="selection"：接收你当前循环的某个参数，这样你要获取多少个参数就是单独写多少次。 -->
            <el-table-column type="selection" align="center"  width="55"></el-table-column>
            <el-table-column v-for="(item, index) in headerList" :key="index" :min-width="item.width" :label="item.description"
                :prop="item.key" :align="item.align" :sortable="item.isSort === true ? 'custom' : false" :show-overflow-tooltip="item.tooltip">
                <!-- slot-scope：来获取插槽slot上面的属性值 -->
            <template slot-scope="scope">
              <select-type ref="selectType" :isEdit="false" :typeId="item.isSel" v-model="scope.row[item.key]" v-if="item.isSel">
              </select-type>
              <!-- stop：事件冒泡 -->
              <span v-else-if="item.key === 'cComunitCode'">
                  <a class="link-type" @click.stop="openDrawer(scope.row,'computationUnits')">{{scope.row.cComunitCode}}</a>
                </span>
              <span v-else>
                <span v-if="item.type === 'DateTime'&&item.key !== 'createDate'">{{scope.row[item.key] | dateFormat}}</span>
                <span v-else>{{scope.row[item.key]}}</span>
              </span>
            </template>
            </el-table-column>
          </el-table>
          <pagination v-show="total>0" :total="total" :page.sync="listQuery.page"
            :limit.sync="listQuery.limit" @pagination="handleCurrentChange" />
    </div>

	<!--使用createdFormId设置Dialog的id,通过id设置内部的样式，防止样式污染-->
    <add-instance ref="dataForm" :sourceCode="crmType"
    createdFormId="computationUnits-dialog"
    :visible.sync="dialogFormVisible"
    :initData="initData">
    </add-instance>
    <!-- initData:数据定义 -->
    <edit-instance ref="editForm" :sourceCode="crmType"
    createdFormId="computationUnits-dialog"
    :visible.sync="dialogEditVisible"
    :initData="temp">
    </edit-instance>
  <!-- sync：同步 -->
    <filter-form ref="queryForm" @filter="handleFilter" :code="crmType"
      :dialog-visible.sync="dialogQueryVisible" />

    <my-transfer :code="crmType" @filter="handleFilter"
      :titles="['待配置列', '显示列']"
      :dialog-visible.sync="dialogSetVisible" />
     <!-- 抽屉 -->
    <drawerViews :drawer.sync="drawer" :tempobj="drawertemp" :objtype="drawerobjtype" :menukeyArray="menukeyArray"></drawerViews>
  </div>
</div>
</template>

<script>
import * as computationUnits from '@/api/computationunits';
import mytable from '@/utils/crmtableFlowV2';

export default {
  name: 'computationUnits',
  components: { },
  mixins: [mytable],
  data() {
    return {
      crmType: 'ComputationUnit',
      listQuery: { // 查询条件
        page: 1,
        limit: 20,
        AccountId: '' // 账套ID
      },
      initData: {
        AccountId: ''
      },
      rules: {}
    };
  },
  created() {
    this.initData.AccountId = this.getAccountId(); // 从V2文件中取到账套ID
    this.listQuery.AccountId = this.getAccountId();
  },
  methods: {
    getApi() {
      return computationUnits;
    },
    openDrawer(row, type) { // 打开抽屉
      this.drawerobjtype = type;
      if (type === 'computationUnits') {
        this.drawertemp = { ...this.drawertemp, ...row };
        this.menukeyArray = [
          { name: '', menukey: 'computationunitsview' }
        ]; // 要显示的标签
        this.drawer = true;
      }
    }
  }
};
</script>
<style>
	.dialog-mini .el-select{
		width:100%;
	}
/* 防止样式污染，使用id为每个页面定义表格体高度 */
#computationUnits-table .el-table__body-wrapper{
  height: calc(100% - 57px) !important;
}
</style>
